import * as React from "react";
import { Chip, ChipProps } from "@mui/material";
import { Localized } from "@fluent/react";
import { DocumentTestOutcomeType } from "../documentTestsApi";

interface OutcomeChipProps {
    outcome?: DocumentTestOutcomeType | null;
}

const outcomeColors: Record<DocumentTestOutcomeType, ChipProps["color"]> = {
    PASSED: "success",
    FAILED: "error",
    NOT_APPLICABLE: "default",
    UNKNOWN: "info",
    PARTIALLYAPPROVED: "warning",
};

export function DocumentTestOutcomeChip({ outcome }: OutcomeChipProps) {
    const key: DocumentTestOutcomeType = outcome ?? "UNKNOWN";

    let label: React.ReactNode;
    switch (outcome) {
        case "PASSED":
            label = (
                <Localized id="document-test-outcome-passed">
                    <span>_Zaliczony</span>
                </Localized>
            );
            break;
        case "FAILED":
            label = (
                <Localized id="document-test-outcome-failed">
                    <span>_Niezaliczony</span>
                </Localized>
            );
            break;
        case "NOT_APPLICABLE":
            label = (
                <Localized id="document-test-outcome-not-applicable">
                    <span>_Nie dotyczy</span>
                </Localized>
            );
            break;
        case "PARTIALLYAPPROVED":
            label = (
                <Localized id="document-test-outcome-partially-approved">
                    <span>_Niejednoznaczny</span>
                </Localized>
            );
            break;
        case "UNKNOWN":
        default:
            label = (
                <Localized id="document-test-outcome-unknown">
                    <span>_Nieznany</span>
                </Localized>
            );
            break;
    }

    return (
        <Chip
            size="small"
            variant="outlined"
            color={outcomeColors[key]}
            label={label}
        />
    );
}
